export const environment = {
  production: false,
  apiUrl: 'https://ppdmsapp.oasisproducts.ng/api/v1',
};
